import { Alert, Box } from '@mui/material';
import { EmailTemplatesCreateEditPage } from 'app/pages/EmailCreateEditPage';

type TemplateUploadEntityPanelProps = {
  dealerId: string;
  initialTemplateType?: string;
  /** When set, preferences table shows only this segment row. */
  filterSegmentName?: string;
};

export default function TemplateUploadEntityPanel({
  dealerId,
  initialTemplateType,
  filterSegmentName,
}: TemplateUploadEntityPanelProps) {
  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to upload a template.
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        minHeight: 0,
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <EmailTemplatesCreateEditPage
        embedded
        initialTemplateType={initialTemplateType}
        filterSegmentName={filterSegmentName}
      />
    </Box>
  );
}

